<template>
	<div v-if="hasPanels" class="action-panels">
		<TransitionGroup name="list">
			<template v-for="p in navStore.actionPanels" :key="p.id">
				<component :is="resoveActionPanelComponent(p.type)" v-bind="panelBinding(p)" :panel="p"></component>
			</template>
		</TransitionGroup>
	</div>
</template>

<script setup lang="ts">
import {ref, computed, onMounted, onUnmounted} from "vue";
import type {FormEnvironment} from "@fd/Types.ts";
import {injectEnv} from "@fd/Environment.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import {resoveActionPanelComponent, panelBinding} from "@/ui/action-panel/ActionPanelResolver.ts";
import crmWS from "@/ws/UniversalSocket.ts";
import {WsRecipient} from "@/ws/WsRecipient.ts";

const env:FormEnvironment = injectEnv();
const navStore = useNavigationStore();

const hasPanels = computed<boolean>(() => {
	return navStore.actionPanels.length > 0;
});

const wsRecipient:WsRecipient = {
	onMessage: (sender:string, message:any) => {
		if (typeof message === "object" && message?.type === "reload") {
			// Reload command from the backend
			navStore.loadActionPanels();
		}
		console.log("Action panels received from '"+sender+"': "+JSON.stringify(message));
	},

	onOpen: () => {
		console.log("Action panels WS opened");
	},

	onClose: () =>  {
		console.log("Action panels WS closed");
	}
}

onMounted(() => {
	crmWS.register("action-panels", wsRecipient);
});
</script>

<style>
.action-panels {
	position: relative;
	display: flex;
	flex-direction: column;
	row-gap: 8px;
}
</style>